module.exports = __webpack_public_path__ + "static/Love_Signs_-_GFX-4d0c1392289e4d60f0973d3ec919da2b.jpg";